import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixPeopleIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M17.0786 21.2057V19.1606C17.0786 18.0758 16.6477 17.0354 15.8806 16.2683C15.1135 15.5013 14.0732 15.0703 12.9884 15.0703H6.85296C5.76815 15.0703 4.72778 15.5013 3.96071 16.2683C3.19363 17.0354 2.7627 18.0758 2.7627 19.1606V21.2057"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.1016 2.92188C15.9787 3.14926 16.7555 3.66146 17.31 4.37807C17.8645 5.09469 18.1654 5.97514 18.1654 6.88125C18.1654 7.78736 17.8645 8.66782 17.31 9.38443C16.7555 10.101 15.9787 10.6132 15.1016 10.8406"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M21.2376 21.2056V19.1605C21.2369 18.2542 20.9353 17.3738 20.3801 16.6575C19.8248 15.9413 19.0474 15.4297 18.1699 15.2031"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9.92034 10.9774C12.1793 10.9774 14.0106 9.14613 14.0106 6.88714C14.0106 4.62815 12.1793 2.79688 9.92034 2.79688C7.66135 2.79688 5.83008 4.62815 5.83008 6.88714C5.83008 9.14613 7.66135 10.9774 9.92034 10.9774Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
